// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as RolloutUtilsJs from "../../../../../dist/libs/booking-flow/src/utils/RolloutUtils.js";
import IndexJs from "../../../../../dist/libs/booking-flow/src/auth/view/components/index.js";
import * as HeaderHelpersJs from "../../../../../dist/libs/booking-flow/src/common/domain/helpers/HeaderHelpers.js";
import ViewPortHOCJs from "../../../../../dist/libs/booking-flow/src/track-order/view/components/ViewPortHOC.js";
import VehicleDetailsModalJs from "../../../../../dist/libs/booking-flow/src/order-review/view/components/VehicleDetailsModal.js";
import OrderReviewDesktopSkeletonLoaderJs from "../../../../../dist/libs/booking-flow/src/order-review/view/components/OrderReviewDesktopSkeletonLoader.js";

var make = IndexJs;

var AuthModal = {
  make: make
};

var make$1 = OrderReviewDesktopSkeletonLoaderJs;

var OrderReviewDesktopSkeletonLoader = {
  make: make$1
};

var make$2 = ViewPortHOCJs;

var ViewPortHOC = {
  make: make$2
};

function mapToVehicleDetails(rescriptType) {
  return {
          vehicleId: rescriptType.vehicle_id,
          name: rescriptType.name,
          capacity: rescriptType.capacity,
          dimensions: rescriptType.dimensions,
          selectedImage: {
            path: rescriptType.selected_image.path,
            altText: rescriptType.selected_image.alt_text
          }
        };
}

var make$3 = VehicleDetailsModalJs;

var VehicleDetailsModal = {
  mapToVehicleDetails: mapToVehicleDetails,
  make: make$3
};

function getBookingFlowSource(prim) {
  return HeaderHelpersJs.getBookingFlowSource();
}

var HeaderHelpers = {
  getBookingFlowSource: getBookingFlowSource
};

function isMobileInRollout(prim0, prim1, prim2) {
  return RolloutUtilsJs.isMobileInRollout(prim0, prim1, prim2 !== undefined ? Caml_option.valFromOption(prim2) : undefined);
}

var RolloutUtils = {
  isMobileInRollout: isMobileInRollout
};

export {
  AuthModal ,
  OrderReviewDesktopSkeletonLoader ,
  ViewPortHOC ,
  VehicleDetailsModal ,
  HeaderHelpers ,
  RolloutUtils ,
}
/* make Not a pure module */
